// Verified against Hyper's bundled Material Design icon stylesheet.
const definitions = [
    ['lightning-bolt', 'Electric'],
    ['fire', 'Natural Gas'], ['gas-cylinder', 'Gas Cylinder'],
    ['solar-power', 'Solar Power'], ['solar-panel', 'Solar Panel'],
    ['weather-sunny', 'Sun'], ['wind-turbine', 'Wind Turbine'],
    ['weather-windy', 'Wind'], ['water', 'Water'], ['hydro-power', 'Hydropower'],
    ['oil', 'Oil'], ['barrel', 'Oil Barrel'], ['fuel', 'Fuel'],
    ['leaf', 'Biomass / Green Energy'], ['atom', 'Nuclear Energy'],
    ['battery', 'Battery Storage'], ['battery-charging', 'Battery Charging'],
    ['power-plug', 'Power Plug'], ['transmission-tower', 'Transmission Tower'],
];

const commodityNames = ['Electric', 'Natural Gas', 'Gas Cylinder', 'Solar', 'Solar', 'Solar',
    'Wind', 'Wind', 'Water', 'Hydropower', 'Oil', 'Oil', 'Fuel', 'Biomass', 'Nuclear',
    'Battery Storage', 'Battery Storage', 'Electric', 'Electric'];
const hyperIcons = definitions.map(([name, label], index) => ({
    value: `mdi mdi-${name}`, label, commodityName: commodityNames[index],
}));
export const commodityIcons = [
    ...hyperIcons.filter(option => option.value !== 'mdi mdi-water'),
    { value: 'fa-droplet', label: 'Water', commodityName: 'Water' },
    { value: 'fa-water', label: 'Wastewater', commodityName: 'Wastewater' },
    { value: 'fa-cloud', label: 'Steam', commodityName: 'Steam' },
    { value: 'fa-temperature-high', label: 'Heating', commodityName: 'Heating' },
    { value: 'fa-snowflake', label: 'Cooling', commodityName: 'Cooling' },
];
const legacyFlash = { value: 'mdi mdi-flash', label: 'Electric', commodityName: 'Electric' };
export const findCommodityIcon = value => [...commodityIcons, legacyFlash, hyperIcons.find(option => option.value === 'mdi mdi-water')].find(option => option.value === String(value ?? '').trim()
    || option.value === `mdi ${String(value ?? '').trim()}`);
